// extracted by mini-css-extract-plugin
export default {"home":"HomePage_home__zD7i6","hero":"HomePage_hero__-w0XY","homep":"HomePage_homep__97ymS","cards":"HomePage_cards__cKJwT","card":"HomePage_card__CaYMV"};